// import { DefaultModality } from 'amazon-chime-sdk-js';
// import { eventChannel } from 'redux-saga';
// import { select, take, takeEvery } from 'redux-saga/effects';
// import * as audioVideoActions from 'store/audioVideo/audioVideoActions';
// import {
//   deviceChangedSaga,
//   realtimeSubscribeToSetCanUnmuteLocalAudioSaga,
//   realtimeSubscribeToVolumeIndicatorCallbackSaga,
// } from 'store/audioVideo/audioVideoSagas';
// import * as chimeActions from 'store/chime/chimeActions';
// import { call, put } from 'store/utils';

// function* watchDeviceChange() {
//   const { audioVideo } = yield select(({ chime }) => ({ audioVideo: chime.audioVideo }));
//   const channel = yield call(createDevicesEventChannel, audioVideo);

//   while (true) {
//     const message = yield take(channel);
//     switch (message.type) {
//       case 'audio-input':
//         yield call(
//           deviceChangedSaga,
//           'audioInputDevices',
//           'currentAudioInputDevice',
//           message.devices
//         );
//         break;
//       case 'video-input':
//         yield call(
//           deviceChangedSaga,
//           'audioInputDevices',
//           'currentAudioOutputDevice',
//           message.devices
//         );
//         break;
//       case 'audio-output':
//         yield call(
//           deviceChangedSaga,
//           'audioOutputDevices',
//           'currentVideoInputDevice',
//           message.devices
//         );
//         break;
//       default:
//         break;
//     }
//   }
// }

// function createDevicesEventChannel(audioVideo) {
//   return eventChannel((emit) => {
//     audioVideo.addDeviceChangeObserver({
//       audioInputsChanged: (freshAudioInputDeviceList) => {
//         emit({ type: 'audio-input', devices: freshAudioInputDeviceList });
//       },
//       audioOutputsChanged: (freshAudioOutputDeviceList) => {
//         emit({ type: 'audio-output', devices: freshAudioOutputDeviceList });
//       },
//       videoInputsChanged: (freshVideoInputDeviceList) => {
//         emit({ type: 'video-input', devices: freshVideoInputDeviceList });
//       },
//     });
//     return () => {
//       // ADD THIS LATER
//     };
//   });
// }

// function* canUnmuteWatcher() {
//   const { audioVideo } = yield select(({ chime }) => ({ audioVideo: chime.audioVideo }));
//   const channel = yield call(createCanUnmuteEventChannel, audioVideo);

//   while (true) {
//     const canUnmute = yield take(channel);

//     yield call(realtimeSubscribeToSetCanUnmuteLocalAudioSaga, canUnmute);
//   }
// }

// function createCanUnmuteEventChannel(audioVideo) {
//   return eventChannel((emit) => {
//     audioVideo.realtimeSubscribeToSetCanUnmuteLocalAudio((canUnmute) => {
//       emit(canUnmute);
//     });
//     return () => {
//       // ADD THIS LATER
//     };
//   });
// }

// function* attendeePresenceWatcher() {
//   const { audioVideo } = yield select(({ chime }) => ({ audioVideo: chime.audioVideo }));
//   const channel = yield call(createAttendeePresenceEventChannel, audioVideo);

//   while (true) {
//     const attendeeResponse = yield take(channel);
//     switch (attendeeResponse.type) {
//       case 'delete-roster-attendee':
//         yield put(
//           chimeActions.removeRosterAttendeeAction({ attendeeId: attendeeResponse.attendeeId })
//         );
//         break;
//       case 'volume-indicator':
//         if (attendeeResponse.muted !== null) {
//           yield call(
//             realtimeSubscribeToVolumeIndicatorCallbackSaga,
//             attendeeResponse.attendeeId,
//             attendeeResponse.muted,
//             attendeeResponse.externalUserId
//           );
//         }
//         break;
//       default:
//         break;
//     }
//   }
// }

// function createAttendeePresenceEventChannel(audioVideo) {
//   return eventChannel((emit) => {
//     audioVideo.realtimeSubscribeToAttendeeIdPresence(
//       //eslint-disable-next-line
//       (presentAttendeeId, present, externalUserId) => {
//         if (!present) {
//           emit({ type: 'delete-roster-attendee', attendeeId: presentAttendeeId });
//           return;
//         }

//         audioVideo.realtimeSubscribeToVolumeIndicator(
//           presentAttendeeId,
//           (attendeeId, volume, muted, signalStrength, externalUserId) => {
//             const baseAttendeeId = new DefaultModality(attendeeId).base();
//             if (baseAttendeeId !== attendeeId) return;
//             emit({ type: 'volume-indicator', attendeeId, muted, externalUserId });
//           }
//         );
//       }
//     );
//     return () => {
//       // ADD THIS LATER
//     };
//   });
// }

// function* activeSpeakerWatcher() {
//   const { audioVideo } = yield select(({ chime }) => ({ audioVideo: chime.audioVideo }));
//   const channel = yield call(createActiveSpeakerEventChannel, audioVideo);

//   while (true) {
//     const activeSpeakers = yield take(channel);

//     yield subscribeToActiveSpeakerDetectorCallbackSaga({ activeSpeakers });
//   }
// }

// function createActiveSpeakerEventChannel(audioVideo) {
//   return eventChannel((emit) => {
//     const speakerWeight = 0.9; // default: 0.9
//     const cutoffThreshold = 0.01; // default: 0.01
//     const silenceThreshold = 0.4; // default: 0.2
//     const takeoverRate = 0.2; // default: 0.2
//     audioVideo.subscribeToActiveSpeakerDetector(
//       new DefaultActiveSpeakerPolicy(
//         speakerWeight,
//         cutoffThreshold,
//         silenceThreshold,
//         takeoverRate
//       ),
//       (activeSpeakers) => emit(activeSpeakers)
//     );
//     return () => {
//       // ADD THIS LATER
//     };
//   });
// }

// function* videoTileWatcher() {
//   const { audioVideo } = yield select(({ chime }) => ({ audioVideo: chime.audioVideo }));
//   const channel = yield call(createVideoTileEventChannel, audioVideo);

//   while (true) {
//     const videoTiles = yield take(channel);
//     switch (videoTiles.type) {
//       case 'tile-update':
//         yield call(audioVideoTileDidUpdateSaga, videoTiles.tileState);
//         break;
//       case 'tile-removed':
//         yield call(audioVideoTileWasRemovedSaga, videoTiles.tileId);
//         break;
//       default:
//         break;
//     }
//   }
// }

// function createVideoTileEventChannel(audioVideo) {
//   return eventChannel((emit) => {
//     audioVideo.addObserver({
//       videoTileDidUpdate: (tileState) => {
//         if (!tileState.boundAttendeeId || !tileState.tileId) {
//           return;
//         }
//         emit({ type: 'tile-update', tileState });
//       },
//       videoTileWasRemoved: (tileId) => {
//         emit({ type: 'tile-removed', tileId });
//       },
//     });
//     return () => {
//       // ADD THIS LATER
//     };
//   });
// }

export default function* audioVideoChannelWatcher() {
  // yield takeEvery(audioVideoActions.devicesChangedChannelAction().type, watchDeviceChange);
  // yield takeEvery(audioVideoActions.canUnmuteChannelAction().type, canUnmuteWatcher);
  // yield takeEvery(audioVideoActions.attendeePresenceChannelAction().type, attendeePresenceWatcher);
  // yield takeEvery(audioVideoActions.activeSpeakerChannelAction().type, activeSpeakerWatcher);
  // yield takeEvery(audioVideoActions.videoTileChannelAction().type, videoTileWatcher);
}
